module.exports = __webpack_public_path__ + "static/wechat_qrcode-3ac33fe452a6dcf86e13b2711da85613.png";